import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Check, ChefHat } from 'lucide-react';

const STEPS = [
  { title: 'Business Profile', desc: 'Your business & TRN are set up.' },
  { title: 'Outlet Setup', desc: 'A main outlet was created. Add more in Settings.' },
  { title: 'Tax Setup', desc: 'UAE VAT 5% configured with AED currency.' },
  { title: 'Add Your Menu', desc: 'Head to Menu to add categories & items.' },
  { title: 'Go Live', desc: 'Start billing on the POS!' },
];

export default function Onboarding() {
  const nav = useNavigate();
  const { tenant } = useAuth();
  const [step, setStep] = useState(0);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="w-full max-w-lg p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-xl bg-primary flex items-center justify-center"><ChefHat className="h-5 w-5 text-primary-foreground" /></div>
          <div>
            <div className="font-display font-bold text-xl">Welcome to RoboChef</div>
            <div className="text-sm text-muted-foreground">{tenant?.name}</div>
          </div>
        </div>
        <div className="space-y-3 mb-6">
          {STEPS.map((s, i) => (
            <div key={i} className={`flex items-start gap-3 p-3 rounded-lg border ${i <= step ? 'bg-accent/40 border-primary/30' : 'opacity-60'}`}>
              <div className={`h-6 w-6 rounded-full flex items-center justify-center text-xs shrink-0 ${i <= step ? 'bg-success text-success-foreground' : 'bg-muted'}`}>
                {i < step ? <Check className="h-3 w-3" /> : i + 1}
              </div>
              <div><div className="font-medium text-sm">{s.title}</div><div className="text-xs text-muted-foreground">{s.desc}</div></div>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          {step < STEPS.length - 1 ? (
            <Button data-testid="onboarding-next" className="flex-1" onClick={() => setStep(step + 1)}>Continue</Button>
          ) : (
            <Button data-testid="onboarding-finish" className="flex-1" onClick={() => nav('/')}>Go to Dashboard</Button>
          )}
          <Button variant="ghost" onClick={() => nav('/')}>Skip</Button>
        </div>
      </Card>
    </div>
  );
}
